import quickSearch from './QuickSearch/texts.js';

export default {
  quickSearch,
  input: {
    placeholder: {
      partNumber: {
        notes:
          'Placeholder in search field, when searching for part/article number',
        message: 'Search by part number',
      },
      partName: {
        notes:
          'Placeholder in search field, when searching for part/article name',
        message: 'Search by part name',
      },
    },
  },
  searchModes: {
    partNumber: {
      notes: 'Searchmode part/article number',
      message: 'Part number',
    },
    partName: {
      notes: 'Searchmode part/article name',
      message: 'Part name',
    },
  },
};
